import { FONT_FAMILY_SRC } from "@common/constants/theme-mantine/constants";

export const ElementsOptions = {
  fonts: [
    {
      cssSrc: FONT_FAMILY_SRC,
    },
  ],
};
